import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsDivider } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        VBreadcrumbs,
        { staticClass: "d-print-none" },
        [
          _c(
            VBreadcrumbsItem,
            { attrs: { exact: true, to: { name: "home", params: {} } } },
            [_vm._v("Home")]
          ),
          _c(VBreadcrumbsDivider, [_vm._v("/")]),
          _c(VBreadcrumbsItem, { attrs: { disabled: "" } }, [
            _vm._v(" Print Package Slip "),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d-print-none pb-5" },
        [
          _c(
            "div",
            { staticClass: "d-flex justify-space-between" },
            [
              _c(VBtn, { on: { click: _vm.goBack } }, [_vm._v(" Back ")]),
              _c(
                "div",
                { staticClass: "d-flex flex-column justify-center" },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "mx-2",
                      on: {
                        click: function ($event) {
                          return _vm.print()
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$vuetify.lang.t("$vuetify.printSetting.print")
                        )
                      ),
                    ]
                  ),
                  _c(VSwitch, {
                    staticClass: "my-auto mt-2",
                    attrs: {
                      "hide-details": "",
                      dense: "",
                      value: true,
                      label: "Condensed",
                    },
                    model: {
                      value: _vm.condensePrint,
                      callback: function ($$v) {
                        _vm.condensePrint = $$v
                      },
                      expression: "condensePrint",
                    },
                  }),
                ],
                1
              ),
              _vm.worksheet
                ? _c(
                    VBtn,
                    {
                      staticClass: "mx-2",
                      attrs: {
                        to: {
                          name: "worksheetPackingCheck",
                          params: { id: _vm.worksheet.id },
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$vuetify.lang.t(
                            "$vuetify.packaging.checkPackaging"
                          )
                        )
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(VDivider),
        ],
        1
      ),
      _vm.loaded
        ? _c("table", { staticStyle: { width: "100%" } }, [
            _c("thead", [
              _c("tr", [
                _c(
                  "th",
                  [
                    _c("company-letter-head", { staticClass: "pb-5" }),
                    _c(VDivider),
                  ],
                  1
                ),
              ]),
            ]),
            _c("tbody", [
              _c("tr", [
                _c("td", [
                  _c(
                    "div",
                    {
                      staticClass:
                        "mx-5 d-flex flex-column flex-sm-row print-flex-row flex-space-between",
                    },
                    [
                      _c("div", { staticClass: "mr-auto" }, [
                        _c("table", { staticClass: "cell-spacing" }, [
                          _c("tr", [
                            _c("td", { staticClass: "font-weight-bold" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$vuetify.lang.t(
                                      "$vuetify.packaging.commodity"
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("td", [
                              _vm._v(_vm._s(_vm.worksheet.productName)),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "font-weight-bold" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$vuetify.lang.t(
                                      "$vuetify.packaging.customer"
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("td", [
                              _vm._v(_vm._s(_vm.worksheet.customerName)),
                            ]),
                          ]),
                          _vm.worksheet.documentNumber
                            ? _c("tr", [
                                _c("td", { staticClass: "font-weight-bold" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$vuetify.lang.t(
                                          "$vuetify.packaging.weightSlip"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _vm.worksheet.documentNumber
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "d-none d-print-block",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.worksheet.documentNumber
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(VTextField, {
                                      staticClass: "d-print-none",
                                      attrs: {
                                        outlined: "",
                                        dense: "",
                                        "hide-details": "",
                                        label: _vm.$vuetify.lang.t(
                                          "$vuetify.packaging.weightSlip"
                                        ),
                                      },
                                      on: {
                                        blur: function ($event) {
                                          return _vm.updateWorksheet(
                                            _vm.worksheet
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.weightSlipNo,
                                        callback: function ($$v) {
                                          _vm.weightSlipNo = $$v
                                        },
                                        expression: "weightSlipNo",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _c("div", { staticClass: "ml-0 ml-md-auto" }, [
                        _c("table", { staticClass: "cell-spacing" }, [
                          _c("tr", [
                            _c("td", { staticClass: "font-weight-bold" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$vuetify.lang.t("$vuetify.base.date")
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatDateYear")(
                                    _vm.worksheet.createTime
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "font-weight-bold" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$vuetify.lang.t(
                                      "$vuetify.packaging.truckNo"
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                            _c(
                              "td",
                              [
                                !_vm.chooseVehicle
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-print-block d-flex justify-space-between",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.worksheet.vehiclePlateNumber
                                                ? _vm.worksheet
                                                    .vehiclePlateNumber
                                                : "N/A"
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          VBtn,
                                          {
                                            staticClass: "ml-4 d-print-none",
                                            attrs: { icon: "", small: "" },
                                            on: {
                                              click: function ($event) {
                                                _vm.chooseVehicle = true
                                              },
                                            },
                                          },
                                          [
                                            _c(VIcon, [
                                              _vm._v("mdi-pencil"),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.chooseVehicle
                                  ? _c("vehicle-select", {
                                      staticClass: "d-print-none",
                                      attrs: { icon: null },
                                      on: {
                                        selected: function ($event) {
                                          _vm.updateWorksheet(_vm.worksheet)
                                          _vm.chooseVehicle = false
                                        },
                                      },
                                      model: {
                                        value: _vm.vehicle,
                                        callback: function ($$v) {
                                          _vm.vehicle = $$v
                                        },
                                        expression: "vehicle",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _c(
                            "tr",
                            {
                              class: _vm.worksheet.certificateNumber
                                ? ""
                                : "d-print-none",
                            },
                            [
                              _c("td", { staticClass: "font-weight-bold" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$vuetify.lang.t(
                                        "$vuetify.packaging.certificate"
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                              _c(
                                "td",
                                [
                                  _vm.certificateNumber
                                    ? _c(
                                        "div",
                                        { staticClass: "d-none d-print-block" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.worksheet.certificateNumber
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(VTextField, {
                                    staticClass: "d-print-none",
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "",
                                      label: _vm.$vuetify.lang.t(
                                        "$vuetify.packaging.certificate"
                                      ),
                                    },
                                    on: {
                                      blur: function ($event) {
                                        return _vm.updateWorksheet(
                                          _vm.worksheet
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.certificateNumber,
                                      callback: function ($$v) {
                                        _vm.certificateNumber = $$v
                                      },
                                      expression: "certificateNumber",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "tr",
                            {
                              class: _vm.worksheet.poNumber
                                ? ""
                                : "d-print-none",
                            },
                            [
                              _c("td", { staticClass: "font-weight-bold" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$vuetify.lang.t(
                                        "$vuetify.packaging.poNumber"
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                              _c(
                                "td",
                                [
                                  _vm.poNumber
                                    ? _c(
                                        "div",
                                        { staticClass: "d-none d-print-block" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.worksheet.poNumber) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(VTextField, {
                                    staticClass: "d-print-none",
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "",
                                      label: _vm.$vuetify.lang.t(
                                        "$vuetify.packaging.poNumber"
                                      ),
                                    },
                                    on: {
                                      blur: function ($event) {
                                        return _vm.updateWorksheet(
                                          _vm.worksheet
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.poNumber,
                                      callback: function ($$v) {
                                        _vm.poNumber = $$v
                                      },
                                      expression: "poNumber",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "mx-8" },
                    [
                      _c(
                        "div",
                        {
                          class: `font-weight-thin text-caption ${
                            _vm.worksheet.customerMemo
                              ? "d-print-block"
                              : "d-print-none"
                          }`,
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$vuetify.lang.t("$vuetify.base.memo")
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          class: `mt-2 pa-2 d-none ${
                            _vm.worksheet.customerMemo
                              ? "d-print-block"
                              : "d-print-none"
                          }`,
                          staticStyle: {
                            border: "1px solid #ccc",
                            "min-height": "80px",
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.worksheet.customerMemo) + " ")]
                      ),
                      _c(VTextarea, {
                        staticClass: "d-print-none",
                        attrs: { "hide-details": "", outlined: "", rows: "2" },
                        on: {
                          blur: function ($event) {
                            return _vm.updateWorksheet(_vm.worksheet)
                          },
                        },
                        model: {
                          value: _vm.customerMemo,
                          callback: function ($$v) {
                            _vm.customerMemo = $$v
                          },
                          expression: "customerMemo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "mx-6 mt-8" }, [
                    _c(
                      "table",
                      { class: `table ${_vm.condensePrint ? "table-sm" : ""}` },
                      [
                        _c("thead", { staticClass: "font-weight-bold" }, [
                          _c("tr", [
                            _c("td"),
                            _c("td", [_vm._v("Lot")]),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.$vuetify.lang.t("$vuetify.base.weight")
                                )
                              ),
                            ]),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.$vuetify.lang.t("$vuetify.base.notes")
                                )
                              ),
                            ]),
                          ]),
                        ]),
                        _c(
                          "tbody",
                          [
                            _vm._l(
                              _vm.groupedEntries(_vm.worksheet),
                              function (entry, index) {
                                return _c(
                                  "tr",
                                  {
                                    key: entry.id,
                                    attrs: {
                                      "align-content": "center",
                                      set: (_vm.lotNumber =
                                        _vm.getEntryLotNumber(
                                          entry.inventoryId,
                                          entry.inventoryUnitId
                                        )),
                                    },
                                  },
                                  [
                                    _c("td", [_vm._v(_vm._s(index + 1) + ".")]),
                                    _c("td", [
                                      _vm._v(" " + _vm._s(_vm.lotNumber) + " "),
                                    ]),
                                    _c("td", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("formatNumber")(
                                              entry.netWeight +
                                                entry.netAdjustmentWeight
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.productInfo
                                              ? _vm.productInfo.measureWeight
                                              : ""
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c("td", [_vm._v(_vm._s(entry.notes))]),
                                  ]
                                )
                              }
                            ),
                            _c("tr", { staticClass: "font-weight-bold" }, [
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$vuetify.lang.t("$vuetify.base.total")
                                  )
                                ),
                              ]),
                              _vm.worksheet.entries
                                ? _c("td", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.groupedEntries(_vm.worksheet)
                                            .length
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.productInfo
                                            ? _vm.productInfo.measureUnit
                                            : ""
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                              _c("td", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("formatNumber")(
                                        _vm.totalWeight(_vm.worksheet.entries)
                                      )
                                    ) +
                                    " " +
                                    _vm._s(
                                      _vm.productInfo
                                        ? _vm.productInfo.measureWeight
                                        : ""
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("td"),
                            ]),
                          ],
                          2
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _c("tr", [
                _c("td", { attrs: { colspan: "4" } }, [
                  _c(
                    "div",
                    { staticClass: "dont-break" },
                    [
                      _c(VDivider),
                      _vm.signatures && _vm.signatures.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-space-between flex-column flex-sm-row mx-2 mt-5 print-flex-row",
                            },
                            _vm._l(_vm.signatures, function (signature) {
                              return _c(
                                "div",
                                {
                                  key: signature.id,
                                  staticClass:
                                    "print-img flex-grow-1 mx-2 mx-md-5 mb-10 mb-md-0",
                                  staticStyle: { "max-width": "300px" },
                                },
                                [
                                  _c("signature", {
                                    attrs: {
                                      signature: signature,
                                      signatureHeader:
                                        signature.signatureHeader,
                                      signatureFooter:
                                        signature.signatureFooter,
                                    },
                                    model: {
                                      value: signature.signature,
                                      callback: function ($$v) {
                                        _vm.$set(signature, "signature", $$v)
                                      },
                                      expression: "signature.signature",
                                    },
                                  }),
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.images && _vm.images.length > 0
                    ? _c(
                        "div",
                        { staticClass: "pt-8" },
                        [
                          _c(VDivider),
                          _c(VSubheader, { staticClass: "justify-center" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$vuetify.lang.t("$vuetify.packaging.images")
                              )
                            ),
                          ]),
                          _c(
                            VRow,
                            { staticClass: "mx-2" },
                            _vm._l(_vm.images, function (img, index) {
                              return _c(
                                VCol,
                                {
                                  key: index,
                                  class: `dont-break ${
                                    img.selected ? "" : "d-print-none"
                                  }`,
                                  attrs: { cols: "6" },
                                },
                                [
                                  _c(VCheckbox, {
                                    staticClass: "d-print-none",
                                    attrs: {
                                      "hide-details": "",
                                      label: _vm.$vuetify.lang.t(
                                        "$vuetify.printSetting.print"
                                      ),
                                    },
                                    model: {
                                      value: img.selected,
                                      callback: function ($$v) {
                                        _vm.$set(img, "selected", $$v)
                                      },
                                      expression: "img.selected",
                                    },
                                  }),
                                  _c(
                                    "div",
                                    { staticStyle: { border: "1px solid" } },
                                    [
                                      _c(VImg, {
                                        staticClass: "print-img",
                                        attrs: {
                                          width: "80%",
                                          contain: "",
                                          "aspect-ratio": "1.7",
                                          src: img.src,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c("div", { staticStyle: { height: "20px" } }),
                    _c(VDivider),
                  ],
                  1
                ),
              ]),
            ]),
            _c("tfoot", [
              _c("tr", [
                _c("td", [
                  _c("div", { staticClass: "d-flex justify-space-between" }, [
                    _vm.isPanya
                      ? _c("span", [
                          _vm._v(
                            "บันทึก : จัดเก็บในแฟ้มเรียงตามลำดับเลขที่, ระยะเวลาจัดเก็บ 2 ปี, วิธีการทำลายย่อย, ผู้รับผิดชอบ MK"
                          ),
                        ])
                      : _vm._e(),
                    _vm.isPanya
                      ? _c("span", [
                          _vm._v("FM-MK-01-08 Rev.01 Eff. Date : 01/12/22"),
                        ])
                      : _vm._e(),
                    !_vm.isPanya
                      ? _c("span", [
                          _vm._v(
                            "แบบฟอร์มใบแจ้งน้ำหนักตะกั่ว F-09-11 ฉบับที่ 03 วันที่บังคับใช้ 14 มิ.ย. 65"
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-end font-weight-light text-caption",
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$vuetify.lang.t(
                              "$vuetify.packaging.printOn",
                              _vm.$options.filters.formatDateYear(_vm.printDate)
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }